let _ = (t)=>t, t;
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { css } from '@emotion/react';
import { Group, tokens } from '@klarna/ui';
import KovfsWarning from 'features/installments/components/kovfsWarning/KovfsWarning';
import SuperscriptedDisclosureList from 'features/installments/components/superscriptedDisclosure/SuperscriptedDisclosureList';
import RichTextMarkdown from 'features/richText/components/richTextMarkdown/RichTextMarkdown';
import { useTranslate } from 'framework/utils/i18n/useTranslate';
const bodyStyles = css(t || (t = _`
  max-width: 100%;

  p,
  p > *,
  a {
    font-size: ${0}px;
    line-height: ${0}px;
  }

  p,
  p > * {
    color: ${0};
  }

  a {
    color: ${0};
    font-weight: 500;
    text-decoration: underline;
  }

  a:hover,
  a:focus,
  a:visited {
    color: ${0};
  }
`), tokens.textSizes['text/desktop/s'], tokens.lineHeights['body/desktop/s'], tokens.colors.light['text/subtle'], tokens.colors.light['text/default'], tokens.colors.light['text/default']);
/**
 * Disclaimer layout shared by every installment surface. Picks a body
 * in precedence `children` → superscripted list → `translationKey`
 * markdown, then stacks `KovfsWarning` below.
 */ const InstallmentDisclaimer = ({ children, disclosureSuperscripts, translationKey, kovfsWarningPaddingHorizontal })=>{
    const translate = useTranslate();
    const body = children !== null && children !== void 0 ? children : disclosureSuperscripts && disclosureSuperscripts.size > 0 ? /*#__PURE__*/ _jsx(SuperscriptedDisclosureList, {
        disclosureSuperscripts: disclosureSuperscripts
    }) : translationKey ? /*#__PURE__*/ _jsx(RichTextMarkdown, {
        sx: bodyStyles,
        children: translate(translationKey)
    }) : null;
    if (!body) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Group, {
        direction: "vertical",
        gap: "space/16",
        children: [
            body,
            /*#__PURE__*/ _jsx(KovfsWarning, {
                paddingHorizontal: kovfsWarningPaddingHorizontal
            })
        ]
    });
};
export default InstallmentDisclaimer;
